<template>
    <div>
        <div class="min-h-screen flex relative lg:static surface-ground">
            <div id="app-sidebar-4" class="h-screen hidden lg:block flex-shrink-0 absolute lg:static left-0 top-0 z-1 w-18rem lg:w-5rem select-none">
                <div class="flex flex-column h-full">
                    <div class="flex align-items-center justify-content-center flex-shrink-0 " style="height:60px">
<!--                        <img src="/images/hyper-light.svg" alt="Image" height="30">-->
                        <img src="/images/neuro2.jpeg" style="height:60px;">
                    </div>
                    <div class="mt-3 select-none">
                        <ul class="list-none p-3 lg:py-3 lg:px-2 m-0">
                            <li>
                                <Link href="/dashboard" v-ripple class="flex align-items-center cursor-pointer p-3 lg:justify-content-center hover:bg-gray-200 border-round text-gray-700 hover:text-gray-900 transition-duration-150 transition-colors p-ripple">
                                    <i class="pi pi-desktop mr-2 lg:mr-0 text-base lg:text-xl"></i>
                                    <span class="font-medium inline lg:hidden">Dashboard</span>
                                </Link>
                            </li>
                            <li>
                                <Link href="/grid_one" v-ripple class="flex align-items-center cursor-pointer p-3 lg:justify-content-center hover:bg-gray-200 border-round text-gray-700 hover:text-gray-900 transition-duration-150 transition-colors p-ripple">
                                    <i class="pi pi-chart-line mr-2 lg:mr-0 text-base lg:text-xl"></i>
                                    <span class="font-medium inline lg:hidden">GridBot</span>
                                </Link>
                            </li>
                            <li>
                                <Link href="/jmc" v-ripple class="flex align-items-center cursor-pointer p-3 lg:justify-content-center hover:bg-gray-200 border-round text-gray-700 hover:text-gray-900 transition-duration-150 transition-colors p-ripple">
                                    <i class="pi pi-chart-line mr-2 lg:mr-0 text-base lg:text-xl"></i>
                                    <span class="font-medium inline lg:hidden">JmcBot</span>
                                </Link>
                            </li>
                            <li>
                                <Link href="/exchanges/bybit" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 lg:justify-content-center hover:bg-gray-200 border-round text-gray-700 hover:text-gray-900 transition-duration-150 transition-colors p-ripple">
                                    <i class="pi pi-book mr-2 lg:mr-0 text-base lg:text-xl"></i>
                                    <span class="font-medium inline lg:hidden">Bybit</span>
                                </Link>
                            </li>
                             <li>
                                <Link href="/settings" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 lg:justify-content-center hover:bg-gray-200 border-round text-gray-700 hover:text-gray-900 transition-duration-150 transition-colors p-ripple">
                                    <i class="pi pi-cog mr-2 lg:mr-0 text-base lg:text-xl"></i>
                                    <span class="font-medium inline lg:hidden">Settings</span>
                                </Link>
                            </li>
<!--                            <li class="lg:relative">-->
<!--                                <a v-ripple class="flex align-items-center cursor-pointer p-3 lg:justify-content-center hover:bg-gray-800 border-round text-gray-300 hover:text-white transition-duration-150 transition-colors p-ripple"-->
<!--                                   v-styleclass="{ selector: '@next', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">-->
<!--                                    <i class="pi pi-chart-line mr-2 lg:mr-0 text-base lg:text-xl" ></i>-->
<!--                                    <span class="font-medium inline lg:hidden">Reports</span>-->
<!--                                    <i class="pi pi-chevron-down ml-auto lg:hidden"></i>-->
<!--                                </a>-->
<!--                                <ul class="list-none pl-3 pr-0 py-0 lg:p-3 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out static lg:absolute left-100 top-0 z-1 bg-gray-900 border-round-right shadow-none lg:shadow-2 w-full lg:w-15rem">-->
<!--                                    <li>-->
<!--                                        <a v-ripple class="flex align-items-center cursor-pointer p-3 hover:bg-gray-800 border-round text-gray-300 hover:text-white transition-duration-150 transition-colors p-ripple"-->
<!--                                           v-styleclass="{ selector: '@next', toggleClass: 'hidden' }">-->
<!--                                            <i class="pi pi-chart-line mr-2"></i>-->
<!--                                            <span class="font-medium">Revenue</span>-->
<!--                                            <i class="pi pi-chevron-down ml-auto"></i>-->
<!--                                        </a>-->
<!--                                        <ul class="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">-->
<!--                                            <li>-->
<!--                                                <a v-ripple class="flex align-items-center cursor-pointer p-3 hover:bg-gray-800 border-round text-gray-300 hover:text-white transition-duration-150 transition-colors p-ripple">-->
<!--                                                    <i class="pi pi-table mr-2"></i>-->
<!--                                                    <span class="font-medium">View</span>-->
<!--                                                </a>-->
<!--                                            </li>-->
<!--                                            <li>-->
<!--                                                <a v-ripple class="flex align-items-center cursor-pointer p-3 hover:bg-gray-800 border-round text-gray-300 hover:text-white transition-duration-150 transition-colors p-ripple">-->
<!--                                                    <i class="pi pi-search mr-2"></i>-->
<!--                                                    <span class="font-medium">Search</span>-->
<!--                                                </a>-->
<!--                                            </li>-->
<!--                                        </ul>-->
<!--                                    </li>-->
<!--                                    <li>-->
<!--                                        <a v-ripple class="flex align-items-center cursor-pointer p-3 hover:bg-gray-800 border-round text-gray-300 hover:text-white transition-duration-150 transition-colors p-ripple">-->
<!--                                            <i class="pi pi-chart-line mr-2"></i>-->
<!--                                            <span class="font-medium">Expenses</span>-->
<!--                                        </a>-->
<!--                                    </li>-->
<!--                                </ul>-->
<!--                            </li>-->

                            <li>
                                <div @click="$inertia.post(route('logout'))" v-ripple class="flex align-items-center cursor-pointer p-3 lg:justify-content-center hover:bg-gray-200 border-round text-gray-700 hover:text-white transition-duration-150 transition-colors p-ripple">

                                    <i class="pi pi-sign-out mr-2 lg:mr-0 text-base lg:text-xl text-gray-700"></i>
                                    <span class="font-medium inline lg:hidden text-gray-700">Logout</span>

                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="min-h-screen flex flex-column relative flex-auto">
                <div class="flex justify-content-between align-items-center px-5 surface-section relative lg:static border-bottom-1 surface-border" style="height:60px">
                    <div class="flex">
                        <a v-ripple class="cursor-pointer block lg:hidden text-700 mr-3 mt-1 p-ripple"
                           v-styleclass="{ selector: '#app-sidebar-4', enterClass: 'hidden', enterActiveClass: 'fadeinleft', leaveToClass: 'hidden', leaveActiveClass: 'fadeoutleft', hideOnOutsideClick: true }">
                            <i class="pi pi-bars text-4xl"></i>
                        </a>

                        <div  class="text-600 flex flex-row align-items-baseline">

                            <div v-if="$page.props.dropdownUsers" class="mr-4">
                                <Dropdown v-model="adminLoginOtherUser" :options="$page.props.dropdownUsers" optionLabel="title" :placeholder="dropdownUser" />
                            </div>

                            <template v-if="$page.props.accountStatsData">
                                <div>Кошелёк USDT: <span class="text-2xl text-900 mr-4 ml-2">{{$page.props.accountStatsData.availableUsdt}}</span></div>

                                <div class="ml-3">Биржи:</div>

                                <div class="ml-2"></div>
                                <div v-if="$page.props.accountStatsData.availableUSDT === null" class="text-grey-600">???</div>
                                <div v-if="$page.props.accountStatsData.availableUSDT < 20" class="text-red-600">{{$page.props.accountStatsData.availableUSDT}}</div>
                                <div v-else>{{$page.props.accountStatsData.availableUSDT}}</div>
                                <div class="ml-1">USDT</div>

                                <div class="ml-2 mr-1">Суммарно все монеты: </div>
                                <div v-if="$page.props.accountStatsData.totalUSDT === null" class="text-grey-600">???</div>
                                <div v-else>~{{$page.props.accountStatsData.totalUSDT}}</div>
                                <div class="ml-1">USDT</div>

                            </template>
                        </div>
                    </div>
                    <a v-ripple class="cursor-pointer block lg:hidden text-700 p-ripple"
                       v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'fadein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">
                        <i class="pi pi-ellipsis-v text-2xl"></i>
                    </a>
                    <ul class="list-none p-0 m-0 hidden lg:flex lg:align-items-center select-none lg:flex-row
                surface-section border-1 lg:border-none surface-border right-0 top-100 z-1 shadow-2 lg:shadow-none absolute lg:static">
                        <li class="mr-4">
                            Текущее время: {{$page.props.currentTime}} UTC
                        </li>
<!--                        <li>-->
<!--                            <a v-ripple class="flex p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer-->
<!--                        transition-duration-150 transition-colors p-ripple">-->
<!--                                <i class="pi pi-inbox text-base lg:text-2xl mr-2 lg:mr-0"></i>-->
<!--                                <span class="block lg:hidden font-medium">Inbox</span>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <a v-ripple class="flex p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer-->
<!--                        transition-duration-150 transition-colors p-ripple">-->
<!--                                <i class="pi pi-bell text-base lg:text-2xl mr-2 lg:mr-0" ></i>-->
<!--                                <span class="block lg:hidden font-medium">Notifications</span>-->
<!--                            </a>-->
<!--                        </li>-->
                    </ul>
                </div>
                <div class="px-3 py-2 flex flex-column flex-auto">
                    <slot/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Dropdown from 'primevue/dropdown';
import { Link } from '@inertiajs/vue2';
export default {
    components:{
        Link, Dropdown
    },
    data(){
        return {
            showingNavigationDropdown: false,
            periodicUpdate: true,
            timer: null,
            adminLoginOtherUser: null
        }
    },
    mounted(){
        this.timer = setInterval(this.reloadPage, 10*60000);
        window.Echo.private(`user.${this.$page.props.auth.user.id}`)
            .listen('LastDateProcessed', (e) => {
                console.log(e);
            });
    },
    methods:{
        reloadPage(){
            if(this.periodicUpdate){
                this.$inertia.reload();
            }
        },
        cancelAutoUpdate () {
            clearInterval(this.timer);
        }
    },
    beforeDestroy() {
        this.cancelAutoUpdate();
    },
    watch: {
        adminLoginOtherUser: function (newVal, oldVal) {
            if(newVal){
                this.cancelAutoUpdate();
                this.$inertia.post('/admin/login_as/', {id: newVal.id});
            }
        }
    },
    computed: {
        dropdownUser(){
            let title = this.$page.props.auth.user_email;
            if(title === "rahatserova55@gmail.com") title = "Grid bot CryptoAI - 1";
            if(title === "demo_grid@demo.com") title = "Grid bot CryptoAI - 2";
            if(title === "demo_grid2@demo.com") title = "Grid bot CryptoAI - 3";
            return title;
        }
    }
}
</script>
